import React from "react";
import { emptyStateIllustrations } from "../assets/empty-states";
import { Card, CardHeader, EmptyState, PageWrapper } from "../components/blocks";
import { LuBell } from "react-icons/lu";

const Notificaciones = () => {
  return (
    <PageWrapper>
      <div className="flex flex-col w-full gap-4">
        <Card>
          <CardHeader
            title="Notificaciones"
            subtitle="Ultimas notificaciones recibidas"
            icon={<LuBell size={24} />}
          />
        </Card>
        <EmptyState
          title="No hay notificaciones"
          subtitle="Vuelve mas tarde para ver las ultimas novedades"
          illustration={emptyStateIllustrations.notifications}
          illustrationAlt="Sin notificaciones disponibles"
        />
      </div>
    </PageWrapper>
  );
};

export default Notificaciones;
